import init from '../../helpers/init';
import {showAlert} from '../main';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  const agreementModal = $('.js-consent-modal');
  const agreeButton = agreementModal.find('button');
  let addContact: JQuery<any>;
  let confirmPdn: JQuery<any>;
  let confirmContactItem: JQuery<any>;

  $(document).on('click', '.js-add-contact', (e) => {
    e.preventDefault();
    const contactId = $(e.currentTarget).data('id');
    const isAgree = $(e.currentTarget).data('agree');
    const isConfirm = $(e.currentTarget).data('confirm');
    const exhibitionXml = $(e.currentTarget).data('exhibition');

    if (isAgree === false) {
      agreementModal.modal('show');
      addContact = $(e.currentTarget);
      return;
    }

    const data = {
      contactId,
      isAgree,
      isConfirm: isConfirm !== undefined && isConfirm ? 1 : 0,
      exhibitionXml
    };

    BX.ajax.runComponentAction('pwd:contacts', 'addContact', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (parseInt(result.data) != 0) {
        $(e.currentTarget).removeClass('js-add-contact');
        $(e.currentTarget).html(`<svg class="icon" width="20" height="18">
                                <use xlink:href="/local/templates/messe/assets/ico/sprite.svg#ico-galka"></use>
                            </svg>`);
        if($('.firm-detail-page').length){
          if($('.js-show-pdn-modal-for-chat').length){
            location.reload();
          }
          if($('.firm-detail-page a.addmark').length){
            $('.firm-detail-page a.addmark').attr('data-agree', 'true');
          }
        }
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

  agreeButton.on('click', (e: JQuery.ClickEvent) => {
    const isAgree = $(e.currentTarget).data('agree');

    if (addContact) {
      addContact.data('agree', isAgree);
      addContact.trigger('click');
    }

    if(confirmPdn){
      confirmPdn.data('agree', isAgree);
      confirmPdn.trigger('click');
    }

    if(confirmContactItem){
      confirmContactItem.data('agree', isAgree);
      confirmContactItem.trigger('click');
    }
  });

  $(document).on('click', '.js-confirm-contact', (e) => {
    e.preventDefault();

    const contactId = $(e.currentTarget).data('id');
    const isAgree = $(e.currentTarget).data('agree');
    const exhibitionXml = $(e.currentTarget).data('exhibition');

    if (isAgree === false) {
      agreementModal.modal('show');
      confirmContactItem = $(e.currentTarget);
      return;
    }

    const data = {
      contactId,
      exhibitionXml
    }

    BX.ajax.runComponentAction('pwd:contacts', 'confirmContact', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (result.data === true) {
        const contactItem = $(`.js-contact[data-id=${contactId}]`);

        $(e.currentTarget).hide();
        contactItem.find('.user-item').removeClass('disabled');
        contactItem.find('.js-decline-contact').hide();
        contactItem.find('.js-add-meeting').show();
        contactItem.find('.js-open-chat').show();
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

  $(document).on('click', '.js-decline-contact', (e) => {
    e.preventDefault();

    const contactId = $(e.currentTarget).data('id');
    const exhibitionXml = $(e.currentTarget).data('exhibition');
    const data = {
      contactId,
      exhibitionXml
    }

    BX.ajax.runComponentAction('pwd:contacts', 'declineContact', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (result.data === true) {
        $(`.js-contact[data-id=${contactId}]`).hide();
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });

  });

  $(document).on('click', '.js-open-chat', (e) => {
    e.preventDefault();

    const chatId = $(e.currentTarget).data('id');
    $('.js-chat-id').val(chatId).trigger('change');
    $('.js-chat-scroll').each(function() {
      scrollChatBand(this);
    });
  });

  $(document).on('click', '.js-open-contacts-dialog', (e) => {
    e.preventDefault();

    $('.js-chat-id').val('').trigger('change');
  });

  $(document).on('click', '.js-send-message', (e) => {
    e.preventDefault();

    const chatId = $(e.currentTarget).data('id');
    const message = $(e.currentTarget).prev('.js-message').html();
    const firm = $(e.currentTarget).data('company');
    const exhibitionXml = $(e.currentTarget).data('exhibition');

    $(e.currentTarget).prev('.js-message').html('');

    const data = {
      chatId,
      message,
      firm: (firm !== undefined && firm.length ? firm : ''),
      exhibitionXml: exhibitionXml
    }

    BX.ajax.runComponentAction('pwd:chat.new', 'sendMessage', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (result.data !== null) {
        const lastMessage = result.data;
        if (lastMessage.message) {
          const myMessageClass = lastMessage.isMine ? 'my-message' : '';
          $('.js-messages-list').append(`<div class="chat-list__message">
                    <div class="chat-message js-chat-message-item ${myMessageClass}">
                        <div class="chat-message__text js-chat-message-item-text">${lastMessage.message}</div>
                        <div class="chat-message__caption">
                            <div class="chat-message__date">${lastMessage.createdAtFormat}</div>
                            <div class="chat-message__author">${lastMessage.senderName}</div>
                        </div>
                    </div>
                </div>`);
          $('.js-chat-scroll').each(function() {
            scrollChatBand(this);
          });
        }
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

  $(document).on('keydown', '.js-message', function(e){
    if (e.ctrlKey && e.keyCode == 13) {
      $('.js-send-message').trigger('click');
    }
  });

  function scrollChatBand(element: HTMLElement) {
    const wrap = $(element);
    const band = wrap.find('.chat-list');
    const scroll = band.outerHeight() - wrap.outerHeight();
    wrap.animate({
      scrollTop: scroll
    }, 300, () => {
      wrap.find('.chat-preloader').remove();
    });
  }

  $(document).on('click', '.js-show-pdn-modal-for-chat', function(e){

    e.preventDefault();
    const contactId = $(e.currentTarget).data('id');
    const isAgree = $(e.currentTarget).data('agree');

    if (isAgree === false) {
      agreementModal.modal('show');
      confirmPdn = $(e.currentTarget);
      return;
    }

    $.ajax({
      method: 'GET',
      url: '/local/ajax/public/Consent/add/?firm=' + contactId,
      dataType: 'text'
    }).done(function (data) {
      if (data.result != 0) {
        location.reload();
      } else {
        showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!')
      }
    }).fail(function () {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
    });
  });

  $(document).on('click', '.js-chat-lang-selector', function(){
    if($('.js-chat-lang-selector-block').length){
      if($('.js-chat-lang-selector-block').hasClass('active')){
        $('.js-chat-lang-selector-block').removeClass('active');
      }else{
        $('.js-chat-lang-selector-block').addClass('active');
      }
    }
  });

  $(document).on('change', '.js-chat-lang-selector-source', function(){
    let v = $(this).val();

    if(v){
      $('.js-chat-lang-source').val(v);
    }else{
      $('.js-chat-lang-source').val('');
    }

    checkChatLangSelect();
  });

  $(document).on('change', '.js-chat-lang-selector-target', function(){
    let v = $(this).val();

    if(v){
      $('.js-chat-lang-target').val(v);
    }else{
      $('.js-chat-lang-target').val('');
    }

    checkChatLangSelect();
  });

  function checkChatLangSelect(){
    // сохраняем настройки
    const data = {
      stringChatId: $('.js-chat-id').val(),
      sourceLang: $('.js-chat-lang-source').val(),
      targetLang: $('.js-chat-lang-target').val(),
    }
    $('.js-chat-scroll').append('<div class="chat-preloader"></div>');
    BX.ajax.runComponentAction('pwd:chat.new', 'saveSettings', {
      data,
      mode: 'class'
    }).then((result: any) => {
      $('.js-chat-id').trigger('change');
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  }

  function isChatLangSelect(){
    if($('.js-chat-lang-source').length
      && $('.js-chat-lang-target').length
      && $('.js-chat-lang-target').val()
      && $('.js-chat-lang-source').val()
    ){
      return true;
    }
    return false;
  }

  $(document).on('click', '.js-chat-message__translate-link', function(e){
    e.preventDefault();

    if(isChatLangSelect()) {
      let p = $(this).parents('.js-chat-message-item');
      let messId = $(this).attr('data-id');

      if (messId && p.length && p.find('.js-chat-message-item-text').length) {
        let txt = p.find('.js-chat-message-item-text').html();
        if (txt && txt.length) {
          let trBlock = p.find('.js-chat-message__translate-result');
          if (trBlock.length) {
            $(this).hide();
            trBlock.html(BX.message('LANGUAGE_ID') === 'en' ? 'Wait...' : 'Переводим...');

            const data = {
              text: txt,
              sourceLang: $('.js-chat-lang-source').val(),
              targetLang: $('.js-chat-lang-target').val(),
              messId: messId
            }

            // переводим
            BX.ajax.runComponentAction('pwd:chat.new', 'translate', {
              data,
              mode: 'class'
            }).then((result: any) => {
              if (result.data != 0) {
                trBlock.html(result.data);
              }else{
                showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Problems with translation. Try later' : 'Возникли проблемы при переводе. Попробуйте позже.');
              }
            }).catch((err: any) => {
              showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
              console.log(err);
            });
          }
        }
      }
    }

  });

  $(document).on('keyup', '.js-chat-find', function(){
    let field = $(this);
    let txt = field.val().toString().trim();

    $('.chat-list .chat-list__item').removeClass('hide');

    if(txt && txt.length){
      $('.chat-list .chat-list__item').each(function(){
        if($(this).find('.chat-list__name').length){
          let chatName = $(this).find('.chat-list__name').html().toString();
          if(chatName.toUpperCase().indexOf(txt.toUpperCase()) < 0){
            $(this).addClass('hide');
          }
        }
      });
    }
  });
});
